import { BaseEntityDto } from '@fleet-beat/core';

export interface ExternalIntegrationData {
  ownerId: string;
}

export interface ExternalIntegration extends BaseEntityDto {
  companyId: string;
  name: string;
  data: ExternalIntegrationData;
  isActive: boolean;
}

export interface ExternalIntegrationUpdateDto {
  data: ExternalIntegrationData;
  isActive: boolean;
}
